module.exports = __webpack_public_path__ + "static/media/portfolio12.0b85909b.jpg";